import React, { Component, Fragment } from 'react';
import { branch } from 'baobab-react/higher-order';

import TestPanelsBlock from '@containers/test-panels-block';
import HistoryPanelsBlock from '@containers/history-panels-block';
import ReconPanelsBlock from '@containers/recon-panels-block';
import {
  RESET_MAP_PICKABLE_PARAMS,
  SET_INITIAL_TEST,
  RESET_TEST,
  SET_INIT_STEP,
  SET_INIT_LOCATION,
} from './actions';

import BLOCKS from '@store/blocks';

class App extends Component {
  switchMode(value) {
    let props = this.props;

    props.dispatch(RESET_MAP_PICKABLE_PARAMS);
    if (value === 0) {
      props.dispatch(SET_INITIAL_TEST);
    } else {
      props.dispatch(RESET_TEST);
    }

    props.dispatch(SET_INIT_LOCATION);
    props.dispatch(SET_INIT_STEP);
  }

  componentWillMount() {
    this.switchMode(this.props.mode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mode !== this.props.mode) {
      this.switchMode(this.props.mode);
    }
  }

  render() {
    let props = this.props;

    return (
      <Fragment>
        {props.mode === 0 && props.activeTest !== '' && <TestPanelsBlock />}
        {props.mode === 1 && <HistoryPanelsBlock />}
        {props.mode === 2 && <ReconPanelsBlock />}
      </Fragment>
    );
  }
}

export default branch(
  {
    activeTest: BLOCKS.TEST_PANELS.ACTIVE_TEST,
    mode: BLOCKS.MODE.VALUE,
  },
  App,
);
